import { JobTitle } from "../../../../globals/interfaces";
import { getTsDate } from "../../../../utils";
import { object, string, date, number, email } from 'yup';

export const defaultValues: Partial<JobTitle> = {
    jobId: '',
    department: '',
    title: '',
    description: '',
    createdAt: getTsDate(),
    createdBy: '',
    modifiedAt: getTsDate(),
    modifiedBy: ''
}

export const createSchema = object().shape({
    jobId: string().required('job ID is a required field'),
    department: string().required(),
    title: string().required(),
    description: string().notRequired().nullable(),
    createdAt: date().required(),
    createdBy: string().required(),
    modifiedAt: date().required(),
    modifiedBy: string().required(),
});

export const updateSchema = createSchema.shape({
    id: number().required()
});